import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=69b3161f&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=69b3161f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b3161f",
  null
  
)

export default component.exports